import {
    VIEWPORT_SET_DIMENSIONS,
    VIEWPORT_ADD_PRESSED_KEY,
    VIEWPORT_DELETE_PRESSED_KEY,
    VIEWPORT_SCALE,
    VIEWPORT_SCALE_PIPES,
    VIEWPORT_POSITION,
    VIEWPORT_POSITION_PIPES,
    VIEWPORT_SWITCH_PANNING,
    GLOBAL_PROJECT_TYPE_CHAMBER,
    VIEWPORT_RESET_POSITION_SCALE, IS_DIRTY,
} from "../lib/types";

export const setDimensions = ( height, width ) => dispatch => {
    dispatch({
        type: VIEWPORT_SET_DIMENSIONS,
        payload: {
            height,
            width,
        },
    });
};

export const addPressedKey = key => dispatch => {
    dispatch({
        type: VIEWPORT_ADD_PRESSED_KEY,
        payload: key,
    });
};

export const deletePressedKey = key => dispatch => {
    dispatch({
        type: VIEWPORT_DELETE_PRESSED_KEY,
        payload: key,
    });
};

export const scaleStage = ( scaleX, scaleY ) => ( dispatch, getState ) => {

    const projectType = getState().globals.projectType;
    const actionType = ( projectType === GLOBAL_PROJECT_TYPE_CHAMBER ) ? VIEWPORT_SCALE : VIEWPORT_SCALE_PIPES;

    dispatch({
        type: actionType,
        payload: {
            scaleX,
            scaleY,
        },
    });
    dispatch({
        type: IS_DIRTY,
        payload: true,
    });
};

export const switchPanning = ( status ) => ( dispatch, getState ) => {
    let isPanning = getState().viewport.isPanning;
    let isOn = ( status !== undefined ) ? status : !isPanning;

    dispatch({
        type: VIEWPORT_SWITCH_PANNING,
        payload: isOn,
    });
};

export const getStageScale = () => ( dispatch, getState ) => {
    let state = getState();
    const projectType = state.globals.projectType;
    if (projectType === GLOBAL_PROJECT_TYPE_CHAMBER) {
        return {
            scaleX: state.viewport.scaleX,
            scaleY: state.viewport.scaleY,
        };
    } else {
        return {
            scaleX: state.viewport.scaleXPipes,
            scaleY: state.viewport.scaleYPipes,
        };
    }
};

export const positionStage = ( positionX, positionY ) => ( dispatch, getState ) => {

    const projectType = getState().globals.projectType;
    const actionType = ( projectType === GLOBAL_PROJECT_TYPE_CHAMBER ) ? VIEWPORT_POSITION : VIEWPORT_POSITION_PIPES;

    dispatch({
        type: actionType,
        payload: {
            positionX,
            positionY,
        },
    });
};

export const getStagePosition = () => ( dispatch, getState ) => {
    let state = getState();
    const projectType = state.globals.projectType;
    if (projectType === GLOBAL_PROJECT_TYPE_CHAMBER) {
        return {
            positionX: state.viewport.positionX,
            positionY: state.viewport.positionY,
        };
    } else {
        return {
            positionX: state.viewport.positionXPipes,
            positionY: state.viewport.positionYPipes,
        };
    }
};

export const resetPositionScale = () => ( dispatch ) => {
    dispatch({
        type: VIEWPORT_RESET_POSITION_SCALE,
        payload: 0,
    });
};



// WEBPACK FOOTER //
// ./src/actions/viewport-actions.js